module.exports = __webpack_public_path__ + "img/home_active.2e0b1ea6.svg";